module.exports = __webpack_public_path__ + "img/mason.aed92eb7.jpg";